import { useDispatch } from 'react-redux';
import { PopupWindowID } from "../../enums/popup-window-id.enum";
import { IBonus } from "../../interfaces/bonus.interface";
import { IQuizError } from "../../interfaces/quiz-error.interface";
import { displayPopupWindow } from "../../redux/display-slice";
import { update } from "../../redux/phone-form-slice";
import { ConfirmationPopup } from "./confirmation-popup/confirmation-popup";
import { IModalWidnow } from '../../interfaces/quiz-content.interface';
import { CustomModal } from './custom-modal/custom-modal';

interface PopupsProps {
  active: boolean;
  errors: IQuizError[]
  activePopupWindowID: PopupWindowID;
  bonuses: IBonus[],
  customModals?: IModalWidnow[];
}

export function Popups({ activePopupWindowID, errors, active, customModals }: PopupsProps) {
  const dispatch = useDispatch();

  const closeHandler = () => {
    dispatch(displayPopupWindow(false));
  }
  
  return (<>
    {activePopupWindowID == PopupWindowID.AGREEMENT && 
      <ConfirmationPopup
        active={active}
        header="Подтвердите свое <br/>согласие с Политикой конфиденциальности"
        buttonText="Подтверждаю"
        onButtonClick={() => dispatch(update({ agreement: true }))}
        onClose={closeHandler}
      />
    }

    {activePopupWindowID == PopupWindowID.VALIDATION &&
      <ConfirmationPopup
        active={active}
        header={errors[0]?.message}
        buttonText="Понятно"
        onButtonClick={closeHandler}
        onClose={closeHandler}
      />
    }

    {activePopupWindowID == PopupWindowID.ANSWER_CHOISE &&
      <ConfirmationPopup
        active={active}
        header="Выберите вариант ответа, <br/>чтобы продолжить"
        buttonText="Понятно"
        onButtonClick={closeHandler}
        onClose={closeHandler}
      />
    }

    {customModals && customModals.map(modal => {
      if (activePopupWindowID == modal.id) {
        return <CustomModal active={active} onClose={closeHandler} modalWindow={modal}/>
      }
    })}
  </>)
}